/* eslint-disable */
import { Grid2, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { authHeader } from '../../../../services/API/apiConfig';
import { Header } from '../../../components/singleComponents/headers';

import { ConstructionCard } from '../../../components/singleComponents/cards/ConstructionCard';
import ClientTour from '../../../components/singleComponents/dialogs/ClientTour';

import {
  IconStyled,
  InputCheckboxStyled,
  NoContentStyled,
  PaperStyled,
  RootStyled,
  SwitchStyled,
} from './homeClient.styles';
import './toogle.css';

export function HomeClient() {
  const navigate = useNavigate();
  const matchesSmall = useMediaQuery('(max-width:750px)');

  const [constructions, setConstructions] = useState([]);
  const [constructionFinished, setConstructionFinished] = useState([]);
  const [constructionInProgress, setConstructionInProgress] = useState([]);
  const [checked, setChecked] = useState(false);

  function sortByName(a, b) {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  }
  function sortConstructions(data) {
    const onGoingConstructions = data.filter(
      ({ status }) => status === 'Em andamento'
    );
    const finishedConstructions = data.filter(
      ({ status }) => status !== 'Em andamento'
    );
    onGoingConstructions.sort(sortByName);
    finishedConstructions.sort(sortByName);
    return [...onGoingConstructions, ...finishedConstructions];
  }

  useEffect(() => {
    api
      .get('/constructions', {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        const sortedConstructions = sortConstructions(data);
        setConstructions(sortedConstructions);
      });
  }, []);

  useEffect(() => {
    const finished = constructions.filter(({ finished }) => finished);
    const inProgress = constructions.filter(({ finished }) => !finished);

    setConstructionFinished(finished);
    setConstructionInProgress(inProgress);
  }, [constructions]);

  function handleConstructionsDetails(id) {
    navigate(`/constructions-details/${id}`);
  }

  let constructionsArray;
  if (matchesSmall) {
    constructionsArray = checked
      ? constructionFinished
      : constructionInProgress;
  } else {
    constructionsArray = constructions;
  }

  return (
    <div style={{ maxWidth: '100vw' }}>
      <Header />
      <Typography
        variant="body2"
        style={{ textAlign: 'center', marginTop: 32, fontSize: 18 }}
      >
        Minhas obras
      </Typography>
      <div className="main-div">
        <InputCheckboxStyled>
          <label className="switch btn-color-mode-switch">
            <SwitchStyled
              type="checkbox"
              name="color_mode"
              id="color_mode"
              value={checked}
              onChange={(e) => setChecked(e.target.checked)}
            />
            <label
              htmlFor="color_mode"
              data-on="Encerradas"
              data-off="Em andamento"
              className="btn-color-mode-switch-inner"
            ></label>
          </label>
        </InputCheckboxStyled>
      </div>
      <RootStyled>
        {!constructions.length ? (
          <PaperStyled>
            <NoContentStyled>
              <IconStyled />
              <Typography style={{ fontSize: '18px' }}>
                Nenhuma obra foi adicionada até o momento
              </Typography>
            </NoContentStyled>
          </PaperStyled>
        ) : (
          <Grid2 container spacing={4}>
            {constructionsArray.map(({ id, name, status, path }) => {
              return (
                <ConstructionCard
                  key={id}
                  id={id}
                  name={name}
                  status={status}
                  facade={path?.url}
                  goToConstructionDetails={handleConstructionsDetails}
                  isClientPage
                />
              );
            })}
          </Grid2>
        )}
      </RootStyled>
    </div>
  );
}
